const { addressFilter } = require('@/vue/filters/addressFilter');

module.exports = addressFilter;
